// extracted by css-extract-rspack-plugin
export default {"cancelErrorBanner":"cancelErrorBanner-pdehUp"};